// src/constants/dataQaIds.js

const dataQaIds = {
  welcomePage: {
    containerId: "welcomePage-containerId",
    lastnameLabelId: "welcomePage-lastnameLabelId",
    headingId: "welcomePage-headingId",
    subHeadingId: "welcomePage-subHeadingId",
    contentId: "welcomePage-contentId",
    signInBtnId: "welcomePage-signInBtnId",
    notAMemberLabelId: "welcomePage-notAMemberLabelId",
    joinForFreeBtnId: "welcomePage-joinForFreeBtnId",
    marriottFillLogoId: "welcomePage-marriottFillLogoId",
  },
  header: {
    containerId: "header-containerId",
    logoId: "header-logoId",
    languageBtnId: "header-languageBtnId",
    signOutBtnId: "header-signOutBtnId",
    languageModalId: "header-languageModalId",
    languageSwitchOptionId: "header-languageSwitchOptionId",
  },
  verificationRightTestIds: {
    titleId: "verificationRight-titleId",
    headingId: "verificationRight-headingId",
    subHeadingId: "verificationRight-subHeadingId",
    acceptAndCompleteBtnId: "verificationRight-acceptAndCompleteBtnId",
    viewTermsAndCondDetailsBtnId:
      "verificationRight-viewTermsAndCondDetailsBtnId",
  },
  VerifiedDetailsPageTestIds: {
    containerId: "verifiedDetailsPage-containerId",
  },
};

module.exports = dataQaIds;
